import React, { Fragment } from "react";
import GenericHeader from "../../common/Header";

class HeaderLayout extends React.Component {
  state = {};
  constructor() {
    super();

    this.headerLayout = [
      {
        label: {
          value: "Item",
          size: "50%",
          maxWidth: "110px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "itemNumber",
          autoFocus: true,
          onBlur: "lookup",
          hotMod: false,
        },
        size: "20%"
      },
      {
        label: {
          value: "Description",
          size: "50%",
          maxWidth: "120px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "description"
        },
        readOnly: true,
        size: "21%"
      },
      {
        label: {
          value: "Line",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "lineCode"
        },
        readOnly: true,
        size: "10%"
      },
      {
        label: {
          value: "Part",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "partNumber"
        },
        readOnly: true,
        size: "10%"
      },

      {
        label: {
          value: "Warehouses"
        },
        item: {
          node: "DCSelector",
          onChange: "lookup",
          value: "",
          obj: this.DCsList,
          intemName: "wse"
        },
        size: "39%"
      },

      {
        label: {
          value: "Shipment Rounding Factor",
          size: "calc(100% - 60px)"
        },
        item: {
          node: "input",
          type: "string",

          value: "",
          intemName: "shipRoundFactor"
        },
        size: "20%"
      },
      {
        label: {
          value: "Shipment Flag",
          size: "calc(100% - 49px)"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          maxLength: 1,
          filter: "[^aAbBdDfFhHoOpPsStTwW ]",
          forceCaps: true,
          intemName: "shipFlag"
        },
        size: "15%"
      },
      {
        label: {
          value: "DC Cases Per Tier",
          size: "calc(100% - 60px)",
          fontSize: "93%"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          intemName: "unitsPerTier"
        },
        size: "15%",
        readOnly: true
      },
      {
        label: {
          value: "DC Tiers Per Pallet",
          size: "calc(100% - 60px)",
          fontSize: "91%"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          intemName: "dctiersOnPallet"
        },
        size: "15%",
        readOnly: true
      },
      {
        label: {
          value: "Master Strategy",
          size: "calc(100% - 60px)"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          intemName: "masterStrategy"
        },
        size: "15%",
        readOnly: true
      },
      {
        label: {
          value: "Modified Date",
          size: "calc(100% - 150px)"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          intemName: "dateDimensionsCh"
        },
        size: "20%",
        readOnly: true
      }
    ];
  }
  componentDidMount() {
    this.setState({ layout: this.headerLayout });
  }

  formatData = props => {
    if (props) {
      this.headerLayout.map((layout, key) => {
        if (layout.item.intemName === props[key].name) {
          layout.item.value =
            props[key].value === undefined ||
            props[key].value === "" ||
            props[key].value === false
              ? ""
              : props[key].value;
          layout.item.obj = props[key].obj;
          layout.item.span = props[key].span;
          layout.label.value = props[key].label;
        }
        return null;
      });
    }

    return null;
  };
  getHeaderInfo = info => {
    this.props.setHeaderInfo({ header: info });
  };
  renderHeader = () => {
    this.formatData(this.props.headerData);
    return (
      <GenericHeader
        jsonObj={this.state.layout}
        setHeaderInfo={this.getHeaderInfo}
        functions={{
          lookup: this.props.lookup,
          setErrorMessage: this.props.setErrorMessage,
          setSuccessMessage: this.props.setSuccessMessage
        }}
      />
    );
  };
  render() {
    return <Fragment>{this.renderHeader()}</Fragment>;
  }
}
export default HeaderLayout;
